import React from 'react';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="mb-4 flex items-center">
      <label htmlFor="category" className="mr-2 text-lg font-semibold">Filtrer par catégorie:</label>
      <select 
        id="category" 
        value={selectedCategory} 
        onChange={(e) => onCategoryChange(e.target.value)}
        className="border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-gray-900 transition duration-200"
      >
        {categories.map(category => (
          <option key={category} value={category}>
            {category === 'all' ? 'Toutes les catégories' : category}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoryFilter;